import { ArrowEdgeFlowZIndexes } from '@/components';

export const activityTreeZIndexes = {
  ...ArrowEdgeFlowZIndexes,
  guideBox: 0,
};
